import { render, staticRenderFns } from "./CreateFaq.vue?vue&type=template&id=b66a4b1a"
import script from "./CreateFaq.vue?vue&type=script&lang=ts"
export * from "./CreateFaq.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports